import styled from 'styled-components';
import { sizes } from 'style';

/**
 * @deprecated use gen.2 Typography instead
 */
const H1 = styled.h1`
  font-size: 30px;
  font-weight: 700;
  margin: 0;
  line-height: 1;

  @media ${sizes.tabletPortrait} {
    font-size: 40px;
  }
`;

export default H1;
